import { useTranslation } from 'react-i18next';

import styles from './ScreenTabChoice.module.css';

export type ScreenTabChoiceProps = {
    /** Autres onglets écran actifs du bar dans ce navigateur (0 = calque masqué). */
    others: number;
    onTakeOver: () => void;
    onKeepBoth: () => void;
};

/**
 * Calque du nouvel onglet écran quand le même bar tourne déjà dans un autre onglet
 * de ce navigateur (services/screenTab/screenTabLock.ts). Par défaut on garde
 * celui-ci ; « Garder les deux » sert aux deux télés branchées sur un même PC.
 */
export function ScreenTabChoice({ others, onTakeOver, onKeepBoth }: ScreenTabChoiceProps) {
    const { t } = useTranslation();
    if (others <= 0) return null;
    return (
        <div className={styles.root} role="dialog" aria-modal="true" aria-labelledby="screen-tab-choice-title">
            <div className={styles.card}>
                <h2 id="screen-tab-choice-title" className={styles.title}>
                    {t('screenTab.choice.title')}
                </h2>
                <p className={styles.text}>{t('screenTab.choice.text')}</p>
                <button type="button" className={styles.primary} onClick={onTakeOver}>
                    {t('screenTab.choice.useHere')}
                </button>
                <button type="button" className={styles.secondary} onClick={onKeepBoth}>
                    {t('screenTab.choice.keepBoth')}
                </button>
            </div>
        </div>
    );
}
